<template>
  <div>
    <div v-show="!showPage">
      <STable
        ref="tableref"
        :url="url"
        :method="method"
        :columns="columns"
        :handles="handles"
        :query="query"
        :toolbar="toolbar"
        :selection="false"
        label-width="80px"
      />
    </div>
    <div v-if="showPage">
      <manualReleaseDetail :data-obj="dataObj" :title="pageTitle" :disabled="formDisabled" @backHome="backHome()" />
    </div>
  </div>
</template>

<script>
import manualReleaseDetail from './manualReleaseDetail'
export default {
  components: { manualReleaseDetail },
  mounted(){
      if(localStorage.getItem('saveMoney') && localStorage.getItem('saveMoney')==1){
        localStorage.removeItem('saveMoney')
      }
  },
  data() {
    return {
      showPage: false,
      formDisabled: false,
      pageTitle: '',
      dataId: '',
      dataObj: {},
      url: '/admin/coupon/getTaskList',
      method: 'post',
      columns: [
        {
          label: '任务名称',
          prop: 'taskName'
        }, {
          label: '发放模式',
          prop: 'type',
          template: function(index, record) {
            if (record.type === 1) {
              return '立即发放'
            } else if (record.type === 3) {
              return '定时发放'
            } else if (record.type === 2) {
              return '周期发放'
            }
          }
        }, {
          label: '任务状态',
          prop: 'status',
          template: function(index, record) {
            if (record.status === 1) {
              return '未开始'
            } else if (record.status === 2) {
              return '进行中'
            } else if (record.status === 3) {
              return '已终止'
            } else if (record.status === 4) {
              return '已结束'
            }
          }
        }, {
          label: '终止原因',
          prop: 'message'
        }, {
          label: '创建人',
          prop: 'creater'
        }, {
          label: '创建时间',
          prop: 'createTime'
        }, {
          label: '下次执行时间',
          prop: 'startTime'
        }
      ],
      handles: {
        width: 200,
        btns: [
          {
            label: '详情',
            permission: 'coupons.manual.release.record.details',
            handle: (index, record) => {
         
              this.dataObj = index
              this.formDisabled = true
              // this.showPage = true
              this.pageTitle = '详情'
                    this.$router.push({
                 path:'./ManualReleaseDetail',
                 query:{
                  title:this.pageTitle,
                  disabled:this.formDisabled,
                  dataObj:encodeURIComponent(JSON.stringify(this.dataObj))
                 }
              })
            }
          },
          {
            label: '修改',
            permission: 'coupons.manual.release.record.update',
            getLabelStyle: record => {
              return record.status !== 1 ? 'color: #c0c4cc;cursor: not-allowed;' : 'color:#409EFF'
            },
            getLabelDisabled: record => {
              return record.status !== 1
            },
            handle: (index, record) => {
              this.dataObj = index
              this.formDisabled = false
              // this.showPage = true
              this.pageTitle = '修改'
                      this.$router.push({
                 path:'./ManualReleaseUpdate',
                 query:{
                  title:this.pageTitle,
                  disabled:this.formDisabled,
                  dataObj:encodeURIComponent(JSON.stringify(this.dataObj))
                 }
              })
            }
          },
          {
            label: '停止',
            permission: 'coupons.manual.release.record.stop',
            getLabelStyle: record => {
              return record.status > 2 ? 'color: #c0c4cc;cursor: not-allowed;' : 'color:red'
            },
            getLabelDisabled: record => {
              return record.status > 2
            },
            handle: (index, record) => {
              this.dataId = index.id
              this.$confirm('此操作将停止当前任务，任务停止后不再发放优惠券，是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.$store.dispatch('form/handle', {
                  url: '/admin/coupon/stopTask?taskId=' + this.dataId,
                  callback: resp => {
                    this.$refs.tableref.queryTable()
                  }
                })
              }).catch(() => {

              })
            }
          }
        ]
      },
      query: [
        {
          label: '任务名称',
          prop: 'taskName',
          placeholder: '请输入任务名称'
        },
        {
          label: '发放模式',
          prop: 'type',
          placeholder: '请选择发放模式',
          type: 'select',
          data: [{
            'label': '立即发放',
            'value': '1'
          }, {
            'label': '周期发放',
            'value': '2'
          }, {
            'label': '定时发放',
            'value': '3'
          }]
        },
        {
          label: '任务状态',
          prop: 'status',
          placeholder: '请选择任务状态',
          type: 'select',
          data: [{
            label: '未开始',
            value: '1'
          }, {
            label: '进行中',
            value: '2'
          }, {
            label: '已结束',
            value: '4'
          }, {
            label: '已终止',
            value: '3'
          }]
        },
        {
          label: '终止原因',
          prop: 'failedType',
          placeholder: '请选择终止原因',
          type: 'select',
          data: [{
            label: '手动终止',
            value: '1'
          }, {
            label: '库存不足',
            value: '2'
          }, {
            label: '优惠券失效',
            value: '3'
          }]
        },
{
          label: '创建时间',
          prop: 'startTime',
          placeholder: '',
          type: 'date2'
        },
      ],
      toolbar: []
    }
  },
  methods: {
    backHome() {
      this.showPage = false
    }
  }
}
</script>

<style lang="less"  scoped>

</style>



// WEBPACK FOOTER //
// src/views/discount/manualRelease.vue